(function () {
    'use strict';

    var module = angular.module('uwAgenda.tasks');
    /* factory for representing TaskState */
    module.factory('TaskState', ['TaskStateEnum', function (TaskStateEnum) {
        var TaskState = function (state) {
            // attributes
            this.name = state.name;
            this.value = state.value;

            //vm attributes
            this.vmBackground = 'blue-soft'; //default
            this.vmNumber = 0; // badge number (fe filter bar)
            this.vmSelected = false; // selected state
            this.vmVisible = true; // visible in bar or dropdown

            // init
            this.init = function () {
                // set background color
                switch (this.value) {
                    case TaskStateEnum.InProgress.value: this.vmBackground = 'blue-soft'; break;
                    case TaskStateEnum.Finished.value: this.vmBackground = 'green-soft'; break;
                    case TaskStateEnum.FollowUpByOperator.value: this.vmBackground = 'grey-mint'; break;
                    case TaskStateEnum.FollowUpByRingfoon.value: this.vmBackground = 'red-thunderbird'; break;
                }

            }; // init

            //init 
            this.init();

        };

        TaskState.prototype = {
            constructor: TaskState
        }; // prototype


        return TaskState;
    }]);
})();